(() => {
  const initialize = () => {
    document.querySelectorAll('[data-sh-sticky-buy]').forEach((bar) => {
      if (bar.dataset.ready) return;
      const form = document.querySelector('product-info form[data-type="add-to-cart-form"]');
      const original = form?.querySelector('[name="add"]');
      if (!form || !original) return;
      bar.dataset.ready = 'true';
      const button = bar.querySelector('[data-sh-sticky-submit]');
      const sync = () => {
        button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
        button.textContent = original.querySelector('span')?.textContent?.trim() || original.textContent.trim();
      };
      new MutationObserver(sync).observe(original, {attributes:true,childList:true,subtree:true});
      new IntersectionObserver(([entry]) => {bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;}, {threshold:0}).observe(original);
      button.addEventListener('click', () => {
        sync();
        if (button.disabled) return;
        if (form.reportValidity()) form.requestSubmit(original);
        else form.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      });
      sync();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
